import { render, staticRenderFns } from "./TipsPage.vue?vue&type=template&id=e8a5f2fe&scoped=true"
import script from "./TipsPage.vue?vue&type=script&lang=js"
export * from "./TipsPage.vue?vue&type=script&lang=js"
import style0 from "./TipsPage.vue?vue&type=style&index=0&id=e8a5f2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a5f2fe",
  null
  
)

export default component.exports